// extracted by mini-css-extract-plugin
export default {"root":"SocialShare-module__[local]___UklTr"};